<template>
  <div v-loading="loading" class="wrapper">
    <el-container class="header_container">
      <el-header>
        <h2>操作日志</h2>
      </el-header>
      <el-main>
        <!-- 日期 -->
        <el-date-picker
          v-model="search.params.time"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          size="mini"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="screen_cont"
          @change="dateChange"
        />
        <!-- 选择广告主 -->
        <el-select
          v-model="table.params.advertiser_id"
          class="upload_input"
          placeholder="请选择广告主"
          size="mini"
          filterable
        >
          <el-option
            v-for="(item, index) in medias_list"
            :key="index"
            :value="item.advertiser_id"
            :label="item.advertiser_name"
          />
        </el-select>
        <!-- 选择广告(组)名称 -->
        <el-input v-model="search.params.value" size="mini" placeholder="输入操作内容，广告组(广告)关键词" />
        <el-button
          style="margin-left:20px"
          icon="el-icon-search"
          size="mini"
          type="primary"
          @click="showChoseData"
        >查询</el-button>
      </el-main>
    </el-container>
    <el-container class="main_container">
      <el-main>
        <el-table :data="table.resource.list" size="mini" border style="width: 100%">
          <af-table-column prop="content_title" label="操作内容" />
          <af-table-column prop="create_time" label="操作时间" />
          <af-table-column prop="object_type" label="日志类型" />
          <af-table-column prop="object_id" label="日志id" />
          <af-table-column prop="object_name" label="日志名称" />
          <af-table-column prop="operator" label="操作人" />
          <af-table-column prop="opt_ip" label="操作IP" />
          <af-table-column label="操作结果">
            <template slot-scope="scope">
              <el-select size="mini" value>
                <el-option
                  v-for="(item,index) in scope.row.content_log"
                  :key="index"
                  :value="item"
                  :label="item"
                />
              </el-select>
            </template>
          </af-table-column>
        </el-table>
        <el-pagination
          background
          :page-size="table.resource.page_info.page_size"
          layout="total, prev, pager, next, jumper"
          :total="table.resource.page_info.total_number"
          class="advertiser_pagination"
          @current-change="logCurrentChange"
        />
      </el-main>
    </el-container>
  </div>
</template>
<script>
// 日志接口
import LogResource from '@/api/log';
import MediasResource from '@/api/medias';
const mediasResource = new MediasResource();
const logResource = new LogResource();

export default {
  name: 'Log',
  data() {
    return {
      loading: false,
      log_info: '',
      medias_list: [],
      search: {
        params: {
          time: [],
          media: '',
          media_account: '',
          dimension: '',
          result: '',
          type: '',
          value: '',
        },
      },
      table: {
        resource: {
          list: [],
          page_info: {},
        },
        params: {
          advertiser_id: '',
          start_time: '',
          end_time: '',
          page: 1,
          limit: 15,
          object_id: [],
        },
      },
    };
  },
  created() {
    this.getMediasList();
  },
  methods: {
    // 获取媒体用户列表
    async getMediasList() {
      this.loading = true;
      const params = {
        type: 'jrtt',
        is_list: true,
      };
      await mediasResource
        .getMediasListApi(params)
        .then(response => {
          this.medias_list = response.list;
        })
        .catch(error => {
          console.log(error);
        });
      this.loading = false;
    },

    // 根据广告主获取数据
    showChoseData() {
      if (this.table.params.start_time === '') {
        this.$message.warning('请先选择开始结束日期');
        return;
      }
      this.getLogList();
    },

    // 根据时间获取列表内容
    dateChange() {
      this.table.params.start_time = this.search.params.time[0];
      this.table.params.end_time = this.search.params.time[1];
      if (this.table.params.advertiser_id === '') {
        this.$message.warning('请选择广告主');
        return;
      }
      this.getLogList();
    },

    // 获取日志列表
    async getLogList() {
      this.loading = true;
      await logResource
        .getLogList(this.table.params)
        .then(response => {
          this.table.resource = response.data;
        })
        .catch(error => {
          console.log(error);
        });
      this.loading = false;
    },

    // 日志列表换页
    logCurrentChange(val) {},
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.wrapper {
  padding: 10px;
}
.el-header {
  height: 40px !important;
  line-height: 40px !important;
  padding: 0 10px;
}
.el-main {
  padding: 10px;
}
.header_container {
  background: #eef0f3;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  .el-header {
    border-bottom: 1px solid #fff;
    h2 {
      margin: 0;
      height: 40px;
      line-height: 40px;
    }
  }
}

.main_container {
  background: #eef0f3;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  margin-top: 5px;
}
.pagination {
  margin-top: 5px;
}
.el-input,
.el-select {
  width: 310px;
}
</style>
